import { Divider, Group, Radio, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setRelatedTasksSelectedOutcome } from '../../../../../store/strategy-store/strategy-store.actions';
import { inkLight, secondaryBase } from '../../../../../styles/design-tokens';
import { Text } from '../../../../../ui-library/typography/typography';
import { useContributingOutcomes } from '../../initiative-performance.hooks';

export const FiltersOutcomes = () => {
  const i18n = useTranslation();
  const contributingOutcomes = useContributingOutcomes();
  const selectedOutcome = useRelatedTasksTabStore((state) => state.selectedOutcome);
  return (
    <Stack>
      {contributingOutcomes.length > 0 && (
        <>
          <Group justify="space-between">
            <Radio
              key="all-outcomes"
              label={<Text size="small">{`All ${i18n.t('strategy.tabs.outcomes')}`}</Text>}
              checked={selectedOutcome === null}
              onChange={() => setRelatedTasksSelectedOutcome(null)}
            />
            <Text size="small" color={inkLight}>
              {contributingOutcomes.length}
            </Text>
          </Group>
          <Divider />
        </>
      )}
      <Stack gap={24}>
        {contributingOutcomes.map((outcome) => (
          <Stack gap={8} key={outcome.id}>
            <Group justify="space-between">
              <Radio
                label={
                  <Text size="small" color={secondaryBase} style={{ lineHeight: '20px' }}>
                    {outcome.key}
                  </Text>
                }
                checked={outcome.id === selectedOutcome}
                onChange={() => setRelatedTasksSelectedOutcome(outcome.id)}
              />
              <Text size="small" color={inkLight}>
                {`${outcome.initiatives?.length || 0} ${i18n.t('strategy.initiatives.initiative').toLowerCase()}${outcome.initiatives?.length === 1 ? '' : 's'}`}
              </Text>
            </Group>
            <Text size="small">{outcome.name}</Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
